export var MuiSelectOverrides = {
  defaultProps: {
    MenuProps: {
      MenuListProps: {
        sx: {
          maxHeight: 250
        }
      }
    }
  }
};